"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var didi = _interopRequireWildcard(require("@/api/didi/didi"));
var _polygonRules = _interopRequireDefault(require("./info/polygonRules"));
var _map_setting = _interopRequireDefault(require("./map_setting"));
var shop = _interopRequireWildcard(require("@/api/jhyc/juyc"));
var _elementChinaAreaData = require("element-china-area-data");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'merchantRulesList',
  components: {
    mapSetting: _map_setting.default,
    polygonFrom: _polygonRules.default
  },
  data: function data() {
    return {
      merchantCityData: _elementChinaAreaData.provinceAndCityData,
      dialogVisible: false,
      fromList: this.$constants.fromList,
      isChecked: false,
      listLoading: false,
      headerNum: [{
        count: '',
        type: '0',
        title: '城市计费规则'
      }, {
        count: '',
        type: '1',
        title: '围栏计费规则'
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        serviceTypeId: null,
        page: 1,
        limit: 20,
        cityId: '',
        subAddressCode: '',
        storeName: '',
        isSwitch: '0',
        addressCode: '',
        serviceType: '',
        isVirtual: null,
        typeId: '',
        merId: null
      },
      autoUpdate: true,
      timeVal: [],
      merId: 0,
      keyNum: 0,
      isDisabled: false,
      indexKey: 0,
      shopInfo: {},
      keyUrl: '',
      serviceData: []
    };
  },
  mounted: function mounted() {
    this.serviceListHandler();
    this.getList(1);
  },
  methods: {
    openDDCityRules: function openDDCityRules(data) {
      console.log(data);
      this.tableFrom.cityId = data.slice(-1)[0];
      console.log(this.tableFrom);
      this.getList(1);
    },
    serviceListHandler: function serviceListHandler() {
      var _this = this;
      shop.serviceListApi({
        merId: 1281,
        page: 1,
        limit: 100
      }).then(function (res) {
        _this.serviceData = res.list;
      }).catch(function () {});
    },
    onMerchantPolygonRulesDetail: function onMerchantPolygonRulesDetail(data) {
      this.$refs.polygonRules.getDetail(data);
      this.$refs.polygonRules.dialogVisible = true;
    },
    onMerchantCityRulesByBatch: function onMerchantCityRulesByBatch() {
      this.$refs.ruleSetting.dialogVisible = true;
    },
    onMerchantCityRulesByDelete: function onMerchantCityRulesByDelete(id) {
      var _this2 = this;
      if (this.tableFrom.isSwitch === '0') {
        didi.merchantRulesByDelete(id).then(function (res) {
          _this2.getList(1);
          _this2.$message.success("\u5220\u9664\u6210\u529F");
        }).catch(function (res) {
          _this2.$message.error(res.message);
        });
      } else {
        didi.merchantPolygonRulesByDelete(id).then(function (res) {
          _this2.getList(1);
          _this2.$message.success("\u5220\u9664\u6210\u529F");
        }).catch(function (res) {
          _this2.$message.error(res.message);
        });
      }
    },
    getLabel: function getLabel(value) {
      var obj = {};
      obj = this.serviceData.find(function (item) {
        return item.id === value;
      });
      if (obj) {
        this.tableFrom.serviceType = obj.serviceType;
        this.tableFrom.isVirtual = obj.serviceCategory;
      } else {
        this.tableFrom.serviceType = null;
        this.tableFrom.isVirtual = null;
      }
      this.getList(1);
    },
    /**
     *  列表
     */
    getList: function getList(num) {
      var _this3 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      if (this.tableFrom.isSwitch === '0') {
        didi.merchantCityRulesListApi({
          page: this.tableFrom.page,
          limit: this.tableFrom.limit,
          storeName: this.tableFrom.storeName,
          cityId: this.tableFrom.cityId,
          serviceType: this.tableFrom.serviceType,
          isVirtual: this.tableFrom.isVirtual,
          addressCode: this.tableFrom.addressCode,
          subAddressCode: this.tableFrom.subAddressCode,
          merId: this.tableFrom.merId
        }).then(function (res) {
          _this3.tableData.data = res.list;
          _this3.tableData.total = res.total;
          _this3.listLoading = false;
          _this3.toggleSelection();
        }).catch(function (res) {
          _this3.listLoading = false;
          _this3.$message.error(res.message);
        });
      } else {
        didi.merchantPolygonRulesListApi({
          page: this.tableFrom.page,
          limit: this.tableFrom.limit,
          storeName: this.tableFrom.storeName,
          cityId: this.tableFrom.cityId,
          serviceType: this.tableFrom.serviceType,
          isVirtual: this.tableFrom.isVirtual,
          addressCode: this.tableFrom.addressCode,
          subAddressCode: this.tableFrom.subAddressCode,
          merId: this.tableFrom.merId
        }).then(function (res) {
          _this3.tableData.data = res.list;
          _this3.tableData.total = res.total;
          _this3.listLoading = false;
          _this3.toggleSelection();
        }).catch(function (res) {
          _this3.listLoading = false;
          _this3.$message.error(res.message);
        });
      }
    },
    toggleSelection: function toggleSelection() {
      var _this4 = this;
      if (this.tableFrom.merId) {
        this.tableData.data.map(function (item) {
          if (item.merId === _this4.tableFrom.merId) {
            _this4.$refs.multipleTable.toggleRowSelection(item);
          } else {
            _this4.$refs.multipleTable.clearSelection();
          }
        });
      }
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList(page);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
    },
    getChange: function getChange() {
      this.getList(1);
      this.dialogVisible = false;
    },
    closeModel: function closeModel() {
      this.dialogVisible = false;
    },
    onMerchantCityMapByBatch: function onMerchantCityMapByBatch(data) {
      this.$refs.mapSetting.showContent(data);
    }
  }
};